import { Box, Typography, useTheme } from '@qbe/ads-core';
import React from 'react';

import { useAppContent } from '~/hooks';

type TotalPriceProps = {
  price: string;
};

const TotalPrice: React.FC<TotalPriceProps> = ({ price }) => {
  const theme = useTheme();
  const { getTextContent } = useAppContent({
    basePath: 'dsme.quote.content',
  });
  return (
    <Box
      // TODO - https://qbe-appservices.atlassian.net/browse/AD1-445
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      color={theme.color.action.primary}
      id="indicative-quote-value"
    >
      <Typography marginBottom={2}>{getTextContent('yourPremium.title')}</Typography>
      <Typography
        variant="h1" // Stag
        fontSize={{ xs: '56px', md: '80px' }}
        fontWeight="fontWeightBold"
        lineHeight={1}
      >
        {price}
      </Typography>
      <Typography variant="body2">{getTextContent('taxesCharges.title')}</Typography>
    </Box>
  );
};

export default TotalPrice;
